module.exports = {"140827100":"新城镇","140827101":"历山镇","140827102":"古城镇","140827103":"王茅镇","140827104":"毛家湾镇","140827200":"蒲掌乡","140827201":"英言乡","140827202":"解峪乡","140827203":"华峰乡","140827204":"长直乡","140827205":"皋落乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140827.json
// module id = 299
// module chunks = 0